import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ElementRef,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { trigger, state, style, transition, animate } from '@angular/animations';

interface ServiceLink {
  name: string;
  path: string;
  icon: string;
}

@Component({
  selector: 'app-explore-more-services',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './explore-more-services.component.html',
  styleUrl: './explore-more-services.component.scss',
  animations: [
    trigger('fadeInOnView', [
      state(
        'hidden',
        style({ opacity: 0, transform: 'translateY(30px)' })
      ),
      state(
        'visible',
        style({ opacity: 1, transform: 'translateY(0)' })
      ),
      transition('hidden => visible', animate('1000ms ease-out'))
    ])
  ]
})
export class ExploreMoreServicesComponent
  implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('sectionRef', { static: true })
  sectionRef!: ElementRef<HTMLElement>;

  isVisible = false;

  private observer!: IntersectionObserver;
  private routerSubscription!: Subscription;

  allServices: ServiceLink[] = [
    { name: 'Custom Software Development', path: 'custom-software-development', icon: '/assets/services/explore-more-services/mobile-app-dev.svg' },
    { name: 'Mobile App Development', path: 'mobile-app-development', icon: '/assets/services/explore-more-services/mobile-app-dev.svg' },
    { name: 'Web Development', path: 'web-development', icon: '/assets/services/explore-more-services/web-dev.svg' },
    { name: 'UI/UX Design', path: 'ui-ux-design', icon: '/assets/services/explore-more-services/ui-ux.svg' },
    { name: 'Digital Marketing', path: 'digital-marketing', icon: '/assets/services/explore-more-services/digital-marketing.svg' },
    { name: 'Testing & QA', path: 'testing-qa', icon: '/assets/services/explore-more-services/testing-qa.svg' },
    { name: 'Data Engineering', path: 'data-engineering', icon: '/assets/services/explore-more-services/data-engineering.svg' },
    { name: 'AI as a Service', path: 'ai-as-a-service', icon: '/assets/services/explore-more-services/ai-as-a-service.svg' },
    { name: 'IT Consulting', path: 'it-consulting', icon: '/assets/services/explore-more-services/it-consulting.svg' }
  ];
  navigateToService(path: string): void {
    this.router.navigate(['/company-services', path]);
  }
  filteredServices: ServiceLink[] = [];

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.filterServices();
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.filterServices());
  }

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.isVisible = true;
          this.observer.disconnect(); // trigger only once
        }
      },
      {
        threshold: 0.25 // 25% visible
      }
    );

    this.observer.observe(this.sectionRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
    this.observer?.disconnect();
  }

  private filterServices(): void {
    const currentUrl = this.router.url;
    this.filteredServices = this.allServices.filter(
      service => !currentUrl.includes(service.path)
    );
  }
}
